import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ModalActions = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'flex-end',
	gap: theme.spacing(1.5),
	padding: theme.spacing(1, 3, 3),
}));
